<template>
  <div class="Integration">
    <div class="title-heading" style="margin: 20px;"> <!-- heading -->
      <p>
        <i style="position: relative; top: 5px;margin-right: 5px;">
          <img src="@/assets/titleBlock/heading1.png" alt="">
        </i>
        {{ $t("message.title.IntegrationSetting") }}
        <i style="position: relative; top: 5px;margin-left: 5px;">
          <img src="@/assets/titleBlock/heading2.png" alt="">
        </i>
      </p>
    </div>

    <div class="integra">
      <div class="item">
        <el-card class="content" shadow="hover">
          <Mail-Setting />
        </el-card>
      </div>
      <div v-for="(item, index) in list" :key="item.id" class="item">
        <el-card class="content" shadow="hover">
          <Notifi-Item :data="item" :change.sync="item.value" ref="item" @submit="subData" />
        </el-card>
      </div>
    </div>

  </div>
</template>


<script>
import axios from "axios";
import NotifiItem from './NotifiItem.vue'
import MailSetting from "./mailSetting.vue";
export default {
  data() {
    return {
      Num: 1,
      list: [

        {
          'title': this.$t('message.title.WeCom'),
          "integrationCode": "WX",
          corpSecret: '',
          appId: '',
          actived: 1,
          corpId: '',
          url: '/pmdm/IntegrationSettings/saveQiyeWXSettings',
          func: this.GET_WX_API,
          id: 10112
        },
        {
          'title': this.$t('message.title.Dingding'),
          "integrationCode": "DingDing",
          corpSecret: '',
          appId: '',
          actived: 1,
          corpId: '',
          url: '/pmdm/IntegrationSettings/saveDingDingSettings',
          func: this.GET_DD_API,
          id: 10111
        }
      ],
    }
  },
  mounted() {
  },
  components: {
    NotifiItem,
    MailSetting
  },
  methods: {

    deleteItem(e) { },

    GET_DD_API() {
      return axios.get(`/pmdm/IntegrationSettings/getDingDingSettings`)
    },
    GET_WX_API() {
      return axios.get(`/pmdm/IntegrationSettings/getQiyeWXSettings`)
    },

    getNotifications() {
      const licenseList = window.sessionStorage.getItem("modules").split(",").map(Number);

      this.list = this.list.filter(i => licenseList.includes(i.id));
      const arr = this.list.map(i => (i.func)());

      Promise.all(arr).then(res => {
        console.log(res);
        res.forEach((i, e) => {
          const { corpSecret = '',
            appId = '',
            actived = 0,
            corpId = '' } = i.data?.object || {};
          const obj = { ...this.list[e], corpSecret, appId, actived, corpId, }
          this.$set(this.list, e, obj)

        });
      })


    },

    subData(data) {
      console.log(data);
      const { integrationCode, corpSecret, appId, corpId, enabled, url } = data;
      const actived = Number(enabled)
      const obj = { integrationCode, corpSecret, appId, corpId, actived };

      axios.post(url, obj).then(res => {
        console.log(res);
        this.$message.success(res.data.message)
      })
    },
    cancel() { }

  },
  created() {
    this.getNotifications();
    // if (arr.includes(10111)) {
    //   this.getNotifications();
    // } else {
    //   this.list = []
    // }
    //
  }
};
</script>

<style scoped>
.integra {
  display: flex;
  flex-wrap: wrap;
  padding: 25px;
  padding-bottom: 0px;
}

.item {
  /* flex: 1; */
  width: 480px;
  padding: 15px 10px;
  margin: 10px;
  margin-left: 0px;
  box-sizing: border-box;
}

.content {
  /* padding: 15px; */
  border: 1px solid #eee;
  /* border-radius: 3px; */
}

.title-heading p {
  font-size: 18px;
  font-weight: 400;
  margin: 0;
}

.notifications {
  width: 100%;
  height: 800px;
  background: #fff;
  overflow: hidden;
}
</style>
